exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-menu[data-v-71c3468f]{border-right:none !important}.el-menu-item[data-v-71c3468f]{font-size:14px;height:49px;line-height:49px}.el-menu-item.is-active[data-v-71c3468f]{background:-webkit-gradient(linear, right top, left top, from(rgba(254,154,106,0.35)), to(#101742));background:linear-gradient(270deg, rgba(254,154,106,0.35) 0%, #101742 100%)}.el-menu-item.is-active[data-v-71c3468f]::after{background:#ff8850;content:\"\";width:4px;height:50px;display:block;position:absolute;right:0;top:0}\n", ""]);

// exports
